import { IOrderPromoDetails } from 'models/orders'

export const getDiscountPayerLabel = (
  promoDetails: Pick<
    IOrderPromoDetails,
    'seller_discount_impact' | 'store_discount_impact' | 'discount_charge_type'
  >
) => {
  const isSellerPaid = (promoDetails.seller_discount_impact ?? 0) > 0
  const isStorePaid = (promoDetails.store_discount_impact ?? 0) > 0

  // У одного заказа платит кто-то один; оба сразу — в супер-заказе, где к заказам
  // разных продавцов применились промокоды разного типа
  if (isSellerPaid && isStorePaid) {
    return 'Продавец и Маркетплейс'
  }
  if (isSellerPaid) {
    return 'Продавец'
  }
  if (isStorePaid) {
    return 'Маркетплейс'
  }
  if (promoDetails.discount_charge_type === 'SELLER') {
    return 'Продавец'
  }
  if (promoDetails.discount_charge_type === 'STORE') {
    return 'Маркетплейс'
  }
  return '—'
}
